import { styled, Button } from "@mui/material";

export const ButtonStyled = styled(Button)(
  ({ theme }) => `
  margin: ${theme.spacing(2, 0, 2)}
`
);
